import * as React from 'react';
import Typography from '@mui/material/Typography';
import MuiLink from '@mui/material/Link';

export default function Footer() {
  return (
    <Typography sx={{ color: "#ffffff", margin: "5rem 0 2rem" }} variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <MuiLink color="inherit" href="#">
        That's The Ticket
      </MuiLink>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}